import { Component, OnInit } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TileDefinition } from '../tile-selection.model';

@Component({
    selector: 'app-tile-selection',
    templateUrl: './tile-selection.component.html',
    styleUrls: ['./tile-selection.component.scss'],
    standalone: false
})
export class TileSelectionComponent extends AbstractWidgetComponent implements OnInit {

  definitions: Array<TileDefinition>;

  constructor(
    public translationService: TranslationService
  ) {
    super();
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'dashboardConfiguration') {
      this.processTilesDefinition(contextChange.value.selectOptions);
    }
  }

  onSetElementAndContext() {
    this.processTilesDefinition(this.dashboardContext.getContextValue('dashboardConfiguration').selectOptions);
  }

  private processTilesDefinition(tilesDefinition: any): void {

    if (tilesDefinition != null) {
      let definitions = new Array<TileDefinition>();
      for (const definition of tilesDefinition) {
        definitions.push(new TileDefinition(definition));
      }
      this.definitions = definitions;
    }
  }

  ngOnInit(): void {
  }

  select(entry: TileDefinition) {
    this.dashboardContext.setContextValue('selectedTile', entry);
  }

  // getTitle(entry: ProcessSelectOption): string {
  //   if (entry.titleDictionaryKey != null) {
  //     return this.translationService.translate(entry.titleDictionaryKey);
  //   }
  //   if (entry.titleDictionaryEntry != null) {
  //     if (entry.titleDictionaryEntry.getValue(this.translationService.language) != null) {
  //       return entry.titleDictionaryEntry.getValue(this.translationService.language).value;
  //     } else if (this.translationService.fallbackLanguages.length > 0) {
  //       return entry.titleDictionaryEntry.getValue(this.translationService.fallbackLanguages[0])?.value;
  //     }
  //   }
  // }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
